









import { defineComponent } from "@vue/composition-api";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "WaitingPaymentModal",
  components: { ModalView, BaseSpinner },
  props: {
    show: { type: Boolean, default: false },
  },
});
